import React from "react";

const Details = ({ rowData }) => {
  const fields = [
    { label: "Name", key: "name" },
    { label: "Location", key: "location" },
    { label: "Branch", key: "branchName" },
    { label: "IP Address", key: "ipAddress" },
    { label: "Operation Start Time", key: "operationTimeStart" },
    { label: "Operation End Time", key: "operationTimeEnd" },
    { label: "Maintenance Start Time", key: "maintenanceTimeStart" },
    { label: "Maintenance End Time", key: "maintenanceTimeEnd" },
    { label: "Software Version", key: "softwareVersion" },
    { label: "Technician", key: "technicianName" },
    { label: "Warning Level Input", key: "warningLevelInput" },
    { label: "Cash Acceptor Capacity", key: "cashAcceptorCapacity" },
    { label: "Alert Threshold", key: "alertThreshold" },
    { label: "Cards Capacity", key: "cardsCapacity" },
    { label: "Cards Available", key: "cardsAvailable" },
    { label: "Daily Transaction Limit", key: "dailyTransactionLimit" },
    { label: "Single Transaction Limit", key: "singleTransactionLimit" },
    { label: "Health Status", key: "healthStatus" },
    { label: "Connectivity Status", key: "connectivityStatus" },
    { label: "Remarks", key: "remarks" },
  ];

  return (
    <div className="main-form">
      <div className="p-fluid formgrid grid">
        {fields.map((field) => (
          <div key={field.key} className="field col-12 md:col-4 mb-3">
            <label>{field.label}</label>
            <p>{rowData?.[field.key] || "N/A"}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Details;
